import moment from 'moment'

export default function formatDateWithTz(date) {
  return moment(date).format('YYYY-MM-DDTHH:mm:ssZ')
}



// WEBPACK FOOTER //
// ./client/utils/formatDateWithTz.js